import { Box, Card, CardContent, Typography, Button, Chip, IconButton } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import DeleteIcon from '@mui/icons-material/Delete';

// Karte einer Gruppe in der Übersicht.
function GruppenCard({ gruppe, nutzerId, onFavorit, onOpen, onDelete, onLeave }) {
    return (
        <Card
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                border: gruppe.ist_favorit ? '2px solid' : '1px solid',
                borderColor: gruppe.ist_favorit ? 'primary.main' : 'divider',
            }}
        >
            <CardContent sx={{ flexGrow: 1 }}>
                <Box display="flex" justifyContent="space-between" alignItems="start" mb={2}>
                    <Typography variant="h6" component="div" sx={{ pr: 1 }}>
                        {gruppe.name}
                    </Typography>
                    <IconButton
                        size="small"
                        onClick={() => onFavorit(gruppe.id)}
                        sx={{ color: gruppe.ist_favorit ? 'primary.main' : 'text.secondary' }}
                    >
                        {gruppe.ist_favorit ? <StarIcon /> : <StarBorderIcon />}
                    </IconButton>
                </Box>

                {gruppe.beschreibung && (
                    <Typography variant="body2" color="text.secondary" mb={2}>
                        {gruppe.beschreibung}
                    </Typography>
                )}

                <Box display="flex" gap={1} mb={2}>
                    <Chip
                        icon={<GroupIcon />}
                        label={`${gruppe.mitglieder_anzahl} Mitglieder`}
                        size="small"
                        variant="outlined"
                    />
                    {gruppe.ist_favorit && (
                        <Chip label="Favorit" size="small" color="primary" />
                    )}
                </Box>

                <Typography variant="caption" color="text.secondary">
                    Erstellt von {gruppe.ersteller_name}
                </Typography>
            </CardContent>

            <Box sx={{ p: 2, pt: 0, display: 'flex', gap: 1 }}>
                <Button
                    variant="contained"
                    fullWidth
                    onClick={() => onOpen(gruppe.id)}
                >
                    Öffnen
                </Button>
                {gruppe.ersteller_id === nutzerId ? (
                    <IconButton
                        color="error"
                        onClick={() => onDelete(gruppe.id, gruppe.name)}
                    >
                        <DeleteIcon />
                    </IconButton>
                ) : (
                    <IconButton
                        color="warning"
                        onClick={() => onLeave(gruppe.id, gruppe.name)}
                    >
                        <ExitToAppIcon />
                    </IconButton>
                )}
            </Box>
        </Card>
    );
}

export default GruppenCard;
